/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Employment Data View Model
    // Holds the employer/employment data
    /**************************************/
    function EmploymentViewModel() {

        var apasFeatureEnabled = sm.portal.utility.isAPASFeatureEnabled();
        var euFeatureEnabled = sm.portal.utility.isEUFeatureEnabled();
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
        // Self-Identification
        var self = this;

        /***  PROPERTIES ***/
        this.DataList = ko.observableArray();
        this.ID = ko.observable();
        this.GID = ko.observable();
        this.EmploymentStatusID = ko.validatedObservable();
        this.OccupationID = ko.validatedObservable();
        this.CurrentEmployer = ko.validatedObservable();
        this.EmployerID = ko.validatedObservable();
        this.sectionIncluded = ko.observable(false);
        /***  PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.EmploymentStatuses = ko.observableArray();
        this.Occupations = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("EmploymentContainer");
        this.Touched = ko.observable(false);
        this.IsRequired = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        this.sectionVisibleByConfig = ko.observable(null);
        this.IsEmploymentEditted = ko.observable(true);
        /*** SECTION PROPERTIES ***/
        sm.portal.vm.custom.setCustomLocalizeKey(self);
        /** ADD/EDIT LIST METHODS **/
        this.WorkingItem = ko.observable(new sm.portal.vm.EmploymentDataItem({
            EmploymentStatuses: this.EmploymentStatuses,
            Occupations: this.Occupations
        }));
        this.OriginalItem = ko.observable(new sm.portal.vm.EmploymentDataItem({
            EmploymentStatuses: this.EmploymentStatuses,
            Occupations: this.Occupations
        }));
        sm.portal.vm.custom.callCustomization('UpdateEmploymentProperties', self);

        this.SaveWorkingChanges = function () {

            var workingItem = new sm.portal.vm.EmploymentDataItem({
                EmploymentStatusID: self.WorkingItem().EmploymentStatusID(),
                EmploymentStatus: self.WorkingItem().EmploymentStatus(),
                OccupationID: self.WorkingItem().OccupationID(),
                Occupation: self.WorkingItem().Occupation(),
                EmployerID: self.WorkingItem().EmployerID(),
                EmployerName: self.WorkingItem().EmployerName(),
                BeginDate: self.WorkingItem().BeginDate(),
                EndDate: self.WorkingItem().EndDate(),
                InEditMode: self.WorkingItem().InEditMode(),
                SectionRequired: self.IsRequired(),
                EmploymentStatuses: this.EmploymentStatuses,
                Occupations: this.Occupations
            });

            var data = {
                workingItem: workingItem,
                self: self
            }
            sm.portal.vm.custom.callCustomization('UpdateEmploymentWorkingItem', data);

            if (workingItem.EmploymentStatusID()) {
                workingItem.EmploymentStatus(self.GetEmploymentStatusNameById(workingItem.EmploymentStatusID()).name);
            }

            if (workingItem.OccupationID()) {
                workingItem.Occupation(self.GetOccupationNameById(workingItem.OccupationID()).name);
            }

            /*** SUBSCRIPTIONS ***/
            workingItem.EmployerName.subscribe(function () {
                if(sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization("SkipSetIdOnEmpNameSubscribe"))){
                    // ensure employer id is zero'd on manual change
                    workingItem.EmployerID(0);
                }
            });
            /*** SUBSCRIPTIONS ***/

            if (workingItem.IsVMValid()) {

                if (!workingItem.InEditMode()) {
                    // This is an Add...
                    self.DataList.push(workingItem);
                } else {
                    // NOTE: Edits automatically bind back to the list (knockout is cool, huh?)
                    if(sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization('IsCustomized'))){
                        workingItem.InEditMode(false);
                    }
                    self.OriginalItem().EmploymentStatusID(workingItem.EmploymentStatusID());
                    self.OriginalItem().EmploymentStatus(workingItem.EmploymentStatus());
                    self.OriginalItem().EmploymentAdddress(workingItem.EmploymentAdddress());
                    self.OriginalItem().OccupationID(workingItem.OccupationID());
                    self.OriginalItem().Occupation(workingItem.Occupation());
                    self.OriginalItem().EmployerID(workingItem.EmployerID());
                    self.OriginalItem().EmployerName(workingItem.EmployerName());
                    self.OriginalItem().BeginDate(workingItem.BeginDate());
                    self.OriginalItem().EndDate(workingItem.EndDate());
                    self.OriginalItem().InEditMode(workingItem.InEditMode());
                }
                sm.portal.vm.custom.callCustomization('SaveEmploymentWorkingChanges', data);
                sm.portal.ui.comboBox();

                // hide the data entry view
                jQuery('.dataEntryView').hide();

                // reset fields for next input
                self.resetWorkingItem();

                // show the display view with one item
                jQuery('.dataDisplayView').show();
                jQuery('.dataDisplayView ul.detailedList li').not('.noneAdded').show();
            }
        };

        this.resetWorkingItem = function () {
            self.WorkingItem(new sm.portal.vm.EmploymentDataItem({
                EmploymentStatuses: this.EmploymentStatuses,
                Occupations: this.Occupations
            }));
            sm.portal.vm.custom.callCustomization('ResetEmploymentWorkingItem', self);
        }

        this.GetEmploymentStatusNameById = function (id) {

            for (var i = 0; i < self.EmploymentStatuses().length; i++) {
                if (self.EmploymentStatuses()[i].Value() === id) {
                    return self.EmploymentStatuses()[i].Text();
                }
            }
            return "";
        }

        this.GetOccupationNameById = function (id) {

            for (var i = 0; i < self.Occupations().length; i++) {
                if (self.Occupations()[i].Value() === id) {
                    return self.Occupations()[i].Text();
                }
            }
            return "";
        }

        this.CancelWorkingChanges = function () {
            self.resetWorkingItem();

            //hide the display view
            jQuery('.dataEntryView').hide();

            // show the entry view
            jQuery('.dataDisplayView').show();
        };
        this.EditItem = function (data, event) {

            self.OriginalItem(data);
            self.WorkingItem(
                new sm.portal.vm.EmploymentDataItem(
                    JSON.parse(ko.toJSON(data))
                )
            );
            self.WorkingItem().InEditMode(true);

            jQuery('.dataDisplayView').hide();
            jQuery('.dataEntryView').show();

            sm.portal.ui.comboBox();
            sm.portal.page.application.fieldHelp();
        };
        this.AddItem = function (data, event) {
            self.resetWorkingItem();
            sm.portal.page.application.fieldHelp();
        };
        this.RemoveItem = function (data, event) {
            var customData = {
                data: data,
                self: self
            }
            var res = sm.portal.vm.custom.callCustomization('RemoveEmploymentItem', customData);
            if (sm.portal.utility.isNullOrEmpty(res)) {
                self.DataList.remove(function (item) {
                    return item.EmploymentStatusID == data.EmploymentStatusID &&
                        item.OccupationID == data.OccupationID &&
                        item.EmployerID == data.EmployerID &&
                        item.BeginDate == data.BeginDate &&
                        item.EndDate == data.EndDate
                });                    
            }
        };
        /** ADD/EDIT LIST METHODS **/

        /***  COMPUTED PROPERTIES ***/
        this.AnythingPopulated = ko.computed(function () {
            var ret = sm.portal.vm.custom.callCustomization('AnythingPopulatedForEmployment', self);
            if (!sm.portal.utility.isNullOrEmpty(ret)) {
                return ret;
            }
            
            ret = false;
            if (typeof sm.portal.vm.apasemployment !== 'undefined' && apasFeatureEnabled) {
                ret = sm.portal.vm.apasemployment.AnythingPopulated(this);
            }
            if (typeof sm.portal.vm.euemployment !== 'undefined' && euFeatureEnabled) {
                ret = sm.portal.vm.euemployment.AnythingPopulated(this);
            }
            if (typeof sm.portal.vm.ukemployment !== 'undefined' && ukFeatureEnabled) {
                ret = sm.portal.vm.ukemployment.AnythingPopulated(this);
            }
            if (!sm.portal.utility.isNullOrEmpty(this.EmploymentStatusID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.OccupationID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.CurrentEmployer())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.EmployerID())) return true;
            return ret;

        }, this);
        if(sm.portal.utility.isNullOrEmpty(self.CompletedFlag)){
            this.Completed = ko.computed(function () {
                if (this.IsRequired()) {
                    return this.AnythingPopulated() && this.Touched();
                } else {
                    return this.Touched();
                }
            }, this);
        }
        /***  COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("Employment", container.Payload.Config);
                // To handle inclusion usecase
                var showSection = container.Payload.Config.ShowSection;
                !sm.portal.utility.isNullOrEmpty(showSection) && this.sectionVisibleByConfig(showSection);
            }
            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();

            this.EmploymentStatuses = smapi.access.loadListItemModels(container.Payload.ListData.EmploymentStatuses, this.EmploymentStatuses);
            this.Occupations = smapi.access.loadListItemModels(container.Payload.ListData.Occupations, this.Occupations);
            
            var customData = {
                container: container,
                self: self
            }
            var res = sm.portal.vm.custom.callCustomization('LoadEmploymentModel', customData);
            if (sm.portal.utility.isNullOrEmpty(res)) {
                if (container.Payload.Employment != null) {
                    this.EmploymentStatusID(container.Payload.Employment.EmploymentStatusID);
                    this.OccupationID(container.Payload.Employment.OccupationID);
                    this.CurrentEmployer(container.Payload.Employment.CurrentEmployer);
                    this.EmployerID(container.Payload.Employment.EmployerID);
                    this.ID(container.Payload.Employment.ID);
                    this.GID(container.Payload.Employment.GID);
                }
                if (typeof sm.portal.vm.apasemployment !== 'undefined' && apasFeatureEnabled) {
                    sm.portal.vm.apasemployment.LoadModel(this, container);
                }
                if (typeof sm.portal.vm.euemployment !== 'undefined' && euFeatureEnabled) {
                    sm.portal.vm.euemployment.LoadModel(this, container);
                }
                if (typeof sm.portal.vm.ukemployment !== 'undefined' && ukFeatureEnabled) {
                    sm.portal.vm.ukemployment.LoadModel(this, container);
                }                    
            }
            this.DataLoading(false);
            this.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[EmploymentVM] Data Loaded'); }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {

            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    self.LoadModel(viewModel.allCustomData().Employment);
                    callback && callback(viewModel.allCustomData().Employment);
                    return;
                }
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=employment&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };

        this.CheckInclusion = function (applicationMID, personMID) {
            if(self.sectionIncluded()) return;
           
            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/CheckApplicationSectionInclusion?sectionName=employment&attemptmid={0}', applicationMID);

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    self.sectionIncluded(true);
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var result = container.Payload.InclusionResult;
                        var sectionsToAdd = Array();
                        var sectionsToRemove = Array();

                        console.log('Inclusion Result for Employment: ' + result);
                        switch (result) {
                            case "Included":
                                sectionsToAdd.push({ section: 'Employment', required: false });
                                break;
                            case "Required":
                                sectionsToAdd.push({ section: 'Employment', required: true });
                                break;
                            case "Exclude":
                                sectionsToRemove.push('Employment');
                                break;
                        }
                        console.log('Calling Maintain Sections');
                        if (self.sectionVisibleByConfig() === false && (result == "Included" || result == "Required")) {
                            sectionsToAdd = null; // If section is hidden by Configuration, don't add the section
                        }
                        viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
                    }
                },
                error: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };

        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            var demoMain = null;
            demoMain = sm.portal.vm.custom.callCustomization('ExtractEmploymentATO', self);
            if (!sm.portal.utility.isNullOrEmpty(demoMain)) {
                return demoMain;
            }
            if (typeof sm.portal.vm.apasemployment !== 'undefined' && apasFeatureEnabled) {
                return sm.portal.vm.apasemployment.ExtractATO(self);
            } else if (typeof sm.portal.vm.euemployment !== 'undefined' && euFeatureEnabled) {
                return sm.portal.vm.euemployment.ExtractATO(self);
            } else if (typeof sm.portal.vm.ukemployment !== 'undefined' && ukFeatureEnabled) {
                return sm.portal.vm.ukemployment.ExtractATO(self);
            }
            else {
                demoMain = new smapi.community.EmploymentModel({
                    EmploymentStatusID: self.EmploymentStatusID(),
                    OccupationID: self.OccupationID(),
                    CurrentEmployer: self.CurrentEmployer(),
                    EmployerID: self.EmployerID(),
                    ID: self.ID(),
                    GID: self.GID(),
                    DutyAFSC: null,
                    Title: null,
                    Supervisor: null,
                    ContactNunber: null
                });
            }
            return demoMain;
        };

        this.CurrentEmployer.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });

        return self;
    };
    function EmploymentDataItem(options) {
        var defaults = {
            EmploymentStatusID: '',
            EmploymentStatus: '',
            OccupationID: '',
            Occupation: '',
            EmployerID: '',
            EmployerName: '',
            BeginDate: '',
            EndDate: '',
            InEditMode: false,
            ID: -1,
            GID: null,
            EmploymentStatuses: null,
            Occupations: null
        };
        sm.portal.vm.custom.callCustomization('UpdateDefaultPropsForEmpDataItem', defaults);
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        self.EmploymentStatusID = ko.validatedObservable(settings.EmploymentStatusID);
        self.EmploymentStatus = ko.validatedObservable(settings.EmploymentStatus);
        self.OccupationID = ko.validatedObservable(settings.OccupationID);
        self.Occupation = ko.validatedObservable(settings.Occupation);
        self.EmployerID = ko.validatedObservable(settings.EmployerID);
        self.EmployerName = ko.validatedObservable(settings.EmployerName);
        self.BeginDate = ko.validatedObservable(settings.BeginDate);
        self.EndDate = ko.validatedObservable(settings.EndDate);
        self.GID = ko.validatedObservable(settings.GID);
        self.ID = ko.validatedObservable(settings.ID);
        self.InEditMode = ko.observable(settings.InEditMode);
        self.CurrentEmployer = ko.observable(settings.CurrentEmployer);

        var data = {
            dataItem : self,
            settings : settings
        }
        sm.portal.vm.custom.callCustomization('UpdateEmploymentDataItem', data);

        if (settings.EmploymentStatuses == undefined || settings.EmploymentStatuses == null) {
            self.EmploymentStatuses = ko.observableArray();
        } else {
            self.EmploymentStatuses = settings.EmploymentStatuses;
        }

        if (settings.Occupations == undefined || settings.Occupations == null) {
            self.Occupations = ko.observableArray();
        } else {
            self.Occupations = settings.Occupations;
        }

        self.ExtractATO = function () {
            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var beginDate = moment(self.BeginDate(), dateFormat).format('YYYY-MM-DD');
            var endDate = moment(self.EndDate(), dateFormat).format('YYYY-MM-DD');

            var stdEmploymentInformation = new smapi.community.EmploymentModel({
                EmploymentStatusID: self.EmploymentStatusID(),
                OccupationID: self.OccupationID(),
                EmployerID: self.EmployerID(),
                BeginDate: beginDate,
                EndDate: endDate,
                ID: self.ID(),
                GID: self.GID(),
                Title: null,
                Supervisor: null,
                ContactNunber: null
            });


            var cusData = {
                self: self,
                stdEmploymentInformation: stdEmploymentInformation
            }

            var res = sm.portal.vm.custom.callCustomization('ExtractDataItemATO', cusData);
            if (!sm.portal.utility.isNullOrEmpty(res)) {
                return res;
            }
            var data = {
                stdEmploymentInformation: stdEmploymentInformation,
                currentEmployerFlexi: self.CurrentEmployerFlexi
            }
            sm.portal.vm.custom.callCustomization('UpdateEmploymentInfo', data);

            var stdEmployerNames = self.EmployerName();

            return {
                EmploymentInformation: stdEmploymentInformation,
                EmployerNames: stdEmployerNames
            };
        }

        /*** VALIDATION METHODS ***/
        sm.portal.vm.custom.callCustomization('OverrideEmploymentValidation', self);

        this.EmploymentStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OccupationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EmployerID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BeginDate.extend({
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            },
            // only need to attach range validator to one of the dates
            smDateRange: {
                params: { start: this.BeginDate, end: this.EndDate },
                message: "Please use a valid date range, with valid dates"
            }
        });
        this.EndDate.extend({
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };


    jQuery.extend(true, sm.portal.vm, {
        EmploymentViewModel: EmploymentViewModel,
        EmploymentDataItem: EmploymentDataItem
    });
})(jQuery);
